export var Sensitivity;
(function (Sensitivity) {
    Sensitivity["Low"] = "Low";
    Sensitivity["Medium"] = "Medium";
    Sensitivity["High"] = "High";
})(Sensitivity || (Sensitivity = {}));
export const SensitivityKey = {
    [Sensitivity.Low]: 'SENSITIVITIES.LOW',
    [Sensitivity.Medium]: 'SENSITIVITIES.MEDIUM',
    [Sensitivity.High]: 'SENSITIVITIES.HIGH',
};
//# sourceMappingURL=sensitivity.js.map